import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { WidgetImage } from '../WidgetImage/WidgetImage';
import { WidgetFeature } from '../WidgetFeatureList/WidgetFeatureList';
import { WidgetClickedElement } from '../../../../stores/UiLoggerStore';
import { WithTranslations, withTranslations } from '../../../../../utils/withTranslations';
import styles from './WidgetFeatureCarousel.scss';
import { widgetFeatureCarouselDataHooks } from './WidgetFeatureCarousel.dataHooks';

interface WidgetFeatureCarouselProps extends WithTranslations {
  selectedFeature: WidgetFeature;
  createElementClickHandler: (element: WidgetClickedElement) => (e: React.MouseEvent) => void;
  isSlidingBackward?: boolean;
  dataHook?: string;
}

const widgetCarouselEnterTimeout = parseInt(styles.widgetCarouseEnterTimeout, 10);
const widgetCarouselLeaveTimeout = parseInt(styles.widgetCarouselLeaveTimeout, 10);

const WidgetFeatureCarouselCmp: React.FC<WidgetFeatureCarouselProps> = ({
  selectedFeature,
  t,
  createElementClickHandler,
  isSlidingBackward = false,
  dataHook,
}) => (
  <div className={styles.carousel} data-hook={dataHook}>
    <TransitionGroup>
      <CSSTransition
        classNames={{
          enter: isSlidingBackward ? styles.carouselSlideBackwardEnter : styles.carouselSlideEnter,
          enterDone: styles.carouselSlideEnterActive,
          exit: styles.carouselSlideLeave,
          exitActive: isSlidingBackward ? styles.carouselSlideBackwardLeaveActive : styles.carouselSlideLeaveActive,
        }}
        timeout={{ enter: widgetCarouselEnterTimeout, exit: widgetCarouselLeaveTimeout }}
        key={selectedFeature.title}
        appear
      >
        <div className={styles.carouselSlide}>
          <div
            className={styles.title}
            onClick={createElementClickHandler('Tool Title')}
            data-hook={widgetFeatureCarouselDataHooks.title()}
          >
            {t(selectedFeature.title)}
          </div>
          <div
            className={styles.description}
            onClick={createElementClickHandler('Tool Description')}
            data-hook={widgetFeatureCarouselDataHooks.description()}
          >
            {t(selectedFeature.description)}
          </div>
          <div
            className={styles.imageWrapper}
            onClick={createElementClickHandler('Tool Image')}
            data-hook={widgetFeatureCarouselDataHooks.imageWrapper()}
          >
            <WidgetImage
              feature={selectedFeature}
              imageClassName={styles.image}
              dataHook={widgetFeatureCarouselDataHooks.image()}
            />
          </div>
        </div>
      </CSSTransition>
    </TransitionGroup>
  </div>
);

export const WidgetFeatureCarousel = withTranslations(WidgetFeatureCarouselCmp);
